import React from 'react';
import Service from '@/pages/dashboard/components/PageContainer/Service';
import { BaseServiceComponentProps } from '@/pages/benchmark/types/commom';
import { IMetricFilterOption } from '../BenchmarkFilter/useData';

export interface IMetricTableServiceProps extends BaseServiceComponentProps {
  [key: string]: any;
}

export default function MetricTableService(props: IMetricTableServiceProps) {
  const {
    style,
    className,
    refreshKey,
    interval,
    dataKey = 'data',
    api,
    children,
    filterVal,
    filterLoading,
    selectMetricList,
    ...resetProps
  } = props || {};

  // todo: 根据筛选器+指标映射表，动态生成tableCommColumns，接口协议，数据转换
  const columns = selectMetricList?.map((item: IMetricFilterOption) => {
    const { metric, metric_ch, metric_en } = item;
    return {
      key: metric,
      headerEn: metric_en,
      headerCn: metric_ch
    };
  });

  return (
    <div className={className} style={style}>
      <Service
        api={api}
        data={{ ...props.data }}
        dataKey={dataKey}
        refreshKey={refreshKey}
        interval={interval}
        filterVal={filterVal}
        filterLoading={filterLoading}
        formatData={(data: any) => {
          // 转换数据格式
          const records =
            Object.keys(data)?.map((key) => ({
              ...data[key],
              key,
            })) || [];
          return records;
        }}
        beforeRequest={(data) => data.filterVal || {}}
        trackData={[]}
      >
        {React.Children.map(children, (child: any) =>
          React.cloneElement(child, {
            ...(resetProps || {}),
            columns,
            filterVal
          }),
        )}
      </Service>
    </div>
  );
}
